/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Form, Button, Modal } from "react-bootstrap";
import * as eventActions from "../../actions/eventActions";
import moment from "moment";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { decode } from "html-entities";
import { imgPath } from "../../utils/imagePath";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, EmailShareButton } from "react-share";
import PropTypes from "prop-types";

const Index = (props) => {

  const { actions } = props;
  const { slug } = useParams();
  const [show, setShow] = useState(false);
  const [getLoader, setGetLoader] = useState(false);
  const { register, formState: { errors }, handleSubmit } = useForm();
  const [showOrganization, setShowOrganization] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [eventDetail, setEventDetail] = useState([]);
  const [likeCount, setLikeCount] = useState([]);
  const [copied, setCopied] = useState(false);

  console.log("", likeCount, copied);

  useEffect(() => {
    document.title = eventDetail.title;
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", eventDetail.title);
  });

  useEffect(() => {
    if (!eventDetail && Object.keys(eventDetail).length === 0) {
      return;
    }
    // Load calendar script only once
    if (globalThis.addeventatc) {
      globalThis.addeventatc.refresh();
      return;
    }
    // SonarQube Security Hotspot reviewed:
    // This script is loaded from a trusted third-party (addevent.com).
    // The library does not provide a fixed version or SRI hash.
    // Risk is accepted as functionality depends on this external service.
    const script = document.createElement("script");
    script.src = "https://cdn.addevent.com/libs/atc/1.6.1/atc.min.js";
    script.integrity = "sha384-37SPFKb8nmPyX31cN+eOIXlahABEhfrs0GWG4ElwAVV7uqqHfwwLWMBi7fXu4WGU";
    script.crossOrigin = "anonymous";
    script.async = true;
    script.onload = () => {
      globalThis.addeventatc.refresh();
    };
    document.body.appendChild(script);
  }, [eventDetail]);

  const getEventDetailsData = (page = 1) => {
    agent
      .get(API.EVENT_DETAIL + "/" + slug, {})
      .then((res) => {
        setEventDetail(res.data.data);
        setLikeCount(res.data.data.likes_count);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getEventDetailsData();
  }, [actions, slug]);

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);
      ReactTooltip.show("Copied!");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const onSubmit = (data) => {
    setGetLoader(true);
    const request = {};
    if (!!data.full_name && !!data.email) {
      request.full_name = data.full_name;
      request.email = data.email;
      request.slug = data.slug;
      request.user_type = data.user_type;
      if (data?.organization) {
        request.organisation = data?.organization;
      }
      actions.handleSubmitRSVP(request, setShow, setGetLoader);
    }
  };

  const getCurrentUrl = () => {
    if (typeof globalThis === "undefined") {
      return "";
    }
    return globalThis.location.href;
  };

  const currentUrl = getCurrentUrl();
  const hasPublishDate = Boolean(eventDetail?.publish_date);

  const isFutureEvent = hasPublishDate && !moment(eventDetail.publish_date).isBefore(moment(), "day");

  const eventEndDate = eventDetail?.end_date || eventDetail?.start_date;
  const origin = typeof globalThis === "object" ? globalThis.origin : "";

  const eventDescription = decode(
    eventDetail.short_description +
    "<br><br>For more details view this " +
    origin +
    "/event-detail/" +
    eventDetail.slug,
    { level: "html5" }
  );

  return (
    <section className="outer_main resourcehubouter">
      <Container>
        <div className="page_content_inner">
          <div className="page_heading px-4 mb-0">
            <h1>{eventDetail.title}</h1>
          </div>

          <div className="d-md-flex py-4 px-4">
            <div className="d-flex align-items-center">
              <div className="resource_name">
                {eventDetail.publish_date && (
                  <small className="d-block date">
                    <img
                      src={imgPath + "time.svg"}
                      alt=""
                    />{" "}
                    {`${moment(new Date(eventDetail?.publish_date)).format(
                      "Do MMM YY"
                    )} ${eventDetail?.calender_start_date?.split("+")[1]} ${eventDetail?.calender_start_date?.split("+")[2]
                      } - ${eventDetail?.calender_end_date?.split("+")[1]} ${eventDetail?.calender_end_date?.split("+")[2]
                      } ${eventDetail?.timezone}`}
                  </small>
                )}
                {eventDetail.address && (
                  <small className="d-block date pt-2 hidden-sm max-w-100"
                    style={{
                      wordBreak: 'break-word',
                    }}>
                    <img
                      src={imgPath + "location.svg"}
                      alt=""
                    />{" "}
                    {eventDetail.address}
                  </small>
                )}
              </div>
            </div>

            <div className="ms-auto pt-2 pt-md-0 flex-wrap d-flex  align-items-center" style={{ width: "35%" }}>
              <ul className="social_links d-flex">
                <li>
                  <FacebookShareButton
                    url={currentUrl}
                    quote={eventDetail.title}
                    data-tip="Share on Facebook"
                  >
                    <i className="fab fa-facebook-square"></i>
                  </FacebookShareButton>
                </li>
                <li>
                  <TwitterShareButton url={currentUrl} title={eventDetail.title} data-tip="Share on X">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2H21.5l-7.5 8.6L22 22h-6.5l-5-6.2L4.5 22H1.2l8-9.2L2 2h6.6l4.5 5.6L18.244 2z" />
                    </svg>
                  </TwitterShareButton>
                </li>
                <li>
                  <LinkedinShareButton
                    url={currentUrl}
                    title={eventDetail.title}
                    data-tip="Share on linkdIn"
                  >
                    <i className="fab fa-linkedin"></i>
                  </LinkedinShareButton>
                </li>
                <li>
                  <EmailShareButton url={currentUrl} data-tip="Share on Email">
                    <i className="fas fa-envelope-square"></i>
                  </EmailShareButton>
                </li>
                <li>
                  <i
                    className="fas fa-link"
                    style={{ cursor: `pointer` }}
                    data-tip="Copied!"
                    data-event="click focus"
                  ></i>
                  <ReactTooltip
                    place="right"
                    type="success"
                    effect="float"
                    globalEventOff={"click"}
                    afterShow={copy}
                    backgroundColor="#ef4343"
                    textColor="#fff"
                  />
                </li>
              </ul>

              {isFutureEvent && (
                <>
                  <div title="Add to Calendar" className="addeventatc">
                    <i className="fa fa-plus"></i> Calendar{" "}

                    <span className="start">{eventDetail.start_date}</span>{""}
                    <span className="end">{eventEndDate}</span>{""}
                    <span className="timezone">{eventDetail.timezone}</span>{""}
                    <span className="title">{eventDetail.title}</span>{""}

                    <span className="description">{""}
                      {decode(eventDetail.addevent_description, { level: "html5" })}
                    </span>{""}

                    <span className="description">{eventDescription}</span>{""}

                    <span className="location">{eventDetail.address}</span>
                  </div>

                  <button
                    className="btn btn_login mt-3 ms-auto mt-sm-0 fs-6 rsvp_btn"
                    onClick={handleShow}
                  >
                    RSVP
                  </button>
                </>
              )}
            </div>
          </div>

          <img
            src={eventDetail.image}
            className="resources_detail_img"
            alt=""
          />

          <p className="m-0 pb-3 pb-md-5" style={{
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            overflowX: 'hidden',
            maxWidth: '100%'
          }}>
            <div
              dangerouslySetInnerHTML={prepareHtml(eventDetail.description)}
              style={{
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                overflowX: 'hidden',
                maxWidth: '100%'
              }}
            ></div>
          </p>

          <div className="d-md-flex py-4 ">
            <div className="d-flex align-items-center">
              <ul className="social_links d-flex " style={{ padding: `0` }}>
                <li>
                  <FacebookShareButton
                    url={currentUrl}
                    quote={eventDetail.title}
                    data-tip="Share on Facebook"
                  >
                    <i className="fab fa-facebook-square"></i>
                  </FacebookShareButton>
                </li>
                <li>
                  <TwitterShareButton url={currentUrl} title={eventDetail.title} data-tip="Share on X">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2H21.5l-7.5 8.6L22 22h-6.5l-5-6.2L4.5 22H1.2l8-9.2L2 2h6.6l4.5 5.6L18.244 2z" />
                    </svg>
                  </TwitterShareButton>
                </li>
                <li>
                  <LinkedinShareButton
                    url={currentUrl}
                    title={eventDetail.title}
                    data-tip="Share on linkdIn"
                  >
                    <i className="fab fa-linkedin"></i>
                  </LinkedinShareButton>
                </li>
                <li>
                  <EmailShareButton url={currentUrl} data-tip="Share on Email">
                    <i className="fas fa-envelope-square"></i>
                  </EmailShareButton>
                </li>
                <li>
                  <i
                    className="fas fa-link"
                    style={{ cursor: `pointer` }}
                    data-tip="Copied!"
                    data-event="click focus"
                  ></i>
                  <ReactTooltip
                    place="right"
                    type="success"
                    effect="float"
                    globalEventOff={"click"}
                    afterShow={copy}
                    backgroundColor="#ef4343"
                    textColor="#fff"
                  />
                </li>
              </ul>
            </div>

            <div className="ms-auto pt-2 pt-md-0 flex-wrap d-flex align-items-center gap-5">
              {eventDetail.previous_slug && (
                <Link
                  className="btn btn_login mt-3 mt-sm-0"
                  to={"/event-detail/" + eventDetail.previous_slug}
                >
                  Previous
                </Link>
              )}

              {eventDetail.next_slug && (
                <Link
                  className="btn btn_login mt-3 mt-sm-0 ml-5"
                  to={"/event-detail/" + eventDetail.next_slug}
                >
                  Next
                </Link>
              )}
            </div>
          </div>
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          className="rsvp_modal calendar-modal"
          centered
        >
          <Modal.Header closeButton>RSVP </Modal.Header>
          <Modal.Body className="arrow_icon thumbnail">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group controlId="rsvp_full_name" className="mb-3">
                <Form.Label>Name*</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control"
                  {...register("full_name", {
                    minLength: 3,
                    required: true,
                  })}
                />
              </Form.Group>
              {errors?.full_name &&
                errors?.full_name?.type === "required" && (
                  <label className="text-left" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_full_name">
                    Please enter Name
                  </label>
                )}
              {errors?.full_name &&
                errors?.full_name?.type === "minLength" && (
                  <label className="text-left" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_full_name">
                    Minimum length should be 3
                  </label>
                )}
              {errors?.full_name && errors?.full_name?.type === "maxLength" && (
                <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                  Your name should contain max 50 characters
                </span>
              )}

              <Form.Group controlId="rsvp_email" className="mb-3">
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control"
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    },
                    maxLength: 50,
                  })}
                />
              </Form.Group>
              {errors?.email && errors?.email?.type === "required" && (
                <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                  Please enter your email address
                </span>
              )}
              {errors?.email && errors?.email?.type === "pattern" && (
                <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                  Invalid email address
                </span>
              )}
              {errors?.email && errors?.email?.type === "maxLength" && (
                <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                  Your email should contain max 50 characters
                </span>
              )}

              <Form.Group controlId="rsvp_user_type" className="mb-3">
                <Form.Label>Are you a vLookUp user?*</Form.Label>
                <Form.Control
                  as="select"
                  className="mb-3"
                  name="user_type"
                  {...register("user_type", {
                    required: true,
                  })}
                  onChange={(e) => {
                    e.target.value === 'None' ? setShowOrganization(true) : setShowOrganization(false);
                  }}
                >
                  <option value="">Please select the category</option>
                  <option value="None">No</option>
                  <option value="Mentee">Mentee</option>
                  <option value="Mentor">Mentor</option>
                </Form.Control>
                {errors?.user_type && errors?.user_type.type === "required" && (
                  <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                    Please select category
                  </span>
                )}

                {showOrganization && <Form.Group controlId="rsvp_organization" className="mb-3">
                  <Form.Label>Organization*</Form.Label>
                  <Form.Control
                    type="text"
                    className="form-control"
                    maxLength={150}
                    {...register("organization", {
                      minLength: 3,
                      required: true,
                      maxLength: 150,
                      validate: {
                        whiteSpace: (value) =>
                          value.trim() ? true : "White spaces not allowed.",
                      },
                    })}
                  />
                </Form.Group>}

                {errors?.organization &&
                  errors?.organization?.type === "whiteSpace" && (
                    <label style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_organization">
                      Whitespace not allowed
                    </label>
                  )}
                {errors?.organization &&
                  errors.organization?.type === "required" && (
                    <label className="text-left" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_organization">
                      Please enter Organization
                    </label>
                  )}
                {errors?.organization &&
                  errors?.organization?.type === "minLength" && (
                    <label className="text-left" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_organization">
                      Minimum length should be 3
                    </label>
                  )}
                {errors?.organization && errors?.organization?.type === "maxLength" && (
                  <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                    Organization name should contain max 50 characters
                  </span>
                )}

                <Form.Control
                  type="hidden"
                  defaultValue={eventDetail.slug}
                  {...register("slug", {})}
                />
              </Form.Group>
              <Button
                type="submit"
                className="btn btn_submit ml-2"
                align="center"
                disabled={getLoader}
              >
                {getLoader ? "Submitting.." : "Submit"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </Container>
    </section>
  );
};

Index.propTypes = {
  isAuth: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  actions: PropTypes.shape({
    handleSubmitRSVP: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    isAuth: state.isAuth,
    userInfo: state.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...eventActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
